import { apiClient } from './api'

export async function generatePresignedUrl(objKey, config){
  const {data} = await apiClient.get(`/api/resource/${objKey}`, config)
  return data
}
